import { useQuery } from 'react-query';
import { APIInjection } from '..';
import { fetchAndMapApiData, ColumnMappedData } from '../utils/apiFetcher';

export function useApiInjectionQuery(apiInjection?: APIInjection[], token?: string) {
  return useQuery<ColumnMappedData[], Error>({
    queryKey: ['apiInjection', apiInjection],
    queryFn: () => fetchAndMapApiData(apiInjection!, token!),
    enabled: Boolean(apiInjection?.length) && Boolean(token),
  });
}
